import { FormControl, FormGroup, Validators } from "@angular/forms";
import { QuestaoEstruturada } from "../../item-questionario/model/questao-estruturada";
import { ItemQuestionario } from "../../questao/item-questionario-base";
import { QuestaoDTO } from "../../questao/model/dto/questao-com-status-respondida.model";
import { Questao } from "../../questao/model/questao.model";
import { ItemQuestionarioFactory } from "../../questao/tipo-questao/item-questionaro-factory";

export class QuestaoParser {

  /**
   * retorna FALSE se:
   * # a questão estruturada possuir menos de 2 opções de resposta
   * # alguma opção de resposta não possuir um nome
   * @param questao 
   */  
  private static validarQuestaoEstruturada(questao: Questao): boolean {
    if ( questao.opcoes && questao.opcoes.length > 1 ) {
      for ( const opcao of questao.opcoes ) {
        if ( !opcao.descricao ) {
          return false;
        }
      }

      return true;
    }

    return false;
  }

  static validarQuestao(questao: Questao): boolean {
    if ( !questao ) {
      return false;
    }
    const isQuestaoEstruturada = ItemQuestionarioFactory.getInstance(questao.tipo)
                                                        .isQuestaoEstruturada();
    
    if ( !questao.nome ) {
      return false;
    }
    if ( isQuestaoEstruturada ) {
      return QuestaoParser.validarQuestaoEstruturada(questao);
    }
    
    return true;
  }

  // transformar para private
  static extrairFormsControlOpcoes(questao: QuestaoDTO): string[] {
    const keys = [];
    for (const [key, value] of Object.entries(questao)) {
      if ( key.startsWith('opcao_') ) {
        // formControls.push({
        //   chave: key,
        //   valor: value
        // });
        keys.push(value);

        delete questao[key];
      }
    }

    return keys;
  }

  // transformar para private
  static removerPropriedadeValueEIdDaOpcaoDeResposta(questao: QuestaoDTO): QuestaoDTO {
    if ( questao.opcoes && questao.opcoes.length > 0 ) {
      const opcoes = questao.opcoes;
      for ( const opcao of opcoes ) {
        for ( const [key, value] of Object.entries(opcao) ) {
          if ( key === 'value' || key === 'id' ) {
            delete opcao[key];
          }
        }
      }
    }

    return questao;
  }

  /**
   * Este metodo faz o parse de um ItemQuestionario
   * retornando um objeto pronto para ser enviado para API <model: Questao>
   * @param itemQuestionario
   */
  static parseItemQuestionarioParaQuestao(itemQuestionario: ItemQuestionario<any>): Questao {
    let novoObjetoQuestao = Object.assign({}, itemQuestionario.questao);    
    const questaoARetornao = QuestaoParser.limparQuestao(novoObjetoQuestao);

    return questaoARetornao;
  }

  /**
   * Este metodo retorna um objeto Questao livre da sujeira adicionada
   * para uso no FormGroup dinamico e de campos utilizados apenas
   * para manipulacao da questao dentro do questionario.
   * O objeto retornado aqui esta pronto para ser enviado para API para processamento.
   * @param questao
   */
  static limparQuestao(questaoDTO: Questao | QuestaoDTO): Questao {
    const questao = JSON.parse(JSON.stringify(questaoDTO));

    let questaoARetornar: QuestaoDTO;
    if ( questao instanceof Questao ) {
      questaoARetornar = QuestaoParser.parseQuestaoParaQuestaoDTO(questao, false);
    }
    else {
      questaoARetornar = questao;
    }

    QuestaoParser.extrairFormsControlOpcoes(questaoARetornar);
    QuestaoParser.removerPropriedadeValueEIdDaOpcaoDeResposta(questaoARetornar);

    if ( questaoARetornar.questaoRespondida ) {
      delete questaoARetornar.questaoRespondida;
    }

    return questaoARetornar;
  }

  static parseQuestaoParaQuestaoDTO(questao: Questao, questaoRespondidade?: boolean): QuestaoDTO {
    questaoRespondidade = questaoRespondidade ? questaoRespondidade : false;

    const questaoDTO = Object.assign({}, questao);
    questaoDTO['questaoRespondidade'] = questaoRespondidade; 

    return questaoDTO as QuestaoDTO;
  }

  static atualizarFormGroupComBaseNaQuestao(formGroup: FormGroup, questao: QuestaoDTO): FormGroup {
    formGroup = QuestaoParser.removerControlesDeOpcaoDeRespostaDoFormGroup(formGroup);
    formGroup = QuestaoParser.adicionarControlesDeOpcaoDeRespostaNoFormGroup(formGroup, questao);

    return formGroup;
  }

  private static removerControlesDeOpcaoDeRespostaDoFormGroup(formGroup: FormGroup): FormGroup {
    Object.keys(formGroup.controls)
          .forEach(key => {
            if ( key.startsWith('opcao_') ) {
              formGroup.removeControl(key);
            }
          });

    return formGroup;
  }

  private static adicionarControlesDeOpcaoDeRespostaNoFormGroup(formGroup: FormGroup, questao: QuestaoDTO): FormGroup {
    if ( questao.opcoes && questao.opcoes.length > 0 ) {
      const opcoes = questao.opcoes;
      for ( const opcao of opcoes ) {
        formGroup.addControl(
                    'opcao_' + opcao.id,
                    new FormControl(opcao.descricao, [Validators.required])
                  );
      }
    }

    return formGroup;
  }  

}